/* eslint-disable @cspell/spellchecker */
import type { IOptions } from 'sanitize-html';
import {
  RICH_TEXT_ALLOWED_ATTRIBUTES,
  RICH_TEXT_ALLOWED_SCHEMES,
  RICH_TEXT_ALLOWED_TAGS,
} from './form-constraints';

export const RICH_TEXT_SANITIZATION_CONFIG: IOptions = {
  allowedTags: [...RICH_TEXT_ALLOWED_TAGS],
  allowedAttributes: RICH_TEXT_ALLOWED_ATTRIBUTES,
  allowedStyles: {
    '*': {
      'text-align': [/^(left|right|center|justify)$/],
      'margin-left': [/^\d+(\.\d+)?(px|em|rem|%)$/],
    },
  },
  allowedSchemes: [...RICH_TEXT_ALLOWED_SCHEMES],
  allowedSchemesByTag: {
    a: [...RICH_TEXT_ALLOWED_SCHEMES],
  },
  allowProtocolRelative: false,
  transformTags: {
    a: (tagName, attribs) => {
      if (attribs['target'] !== '_blank') {
        return { tagName, attribs };
      }

      const existingRelParts = (attribs['rel'] ?? '')
        .split(/\s+/)
        .map((p) => p.trim())
        .filter(Boolean);

      const relParts = new Set(existingRelParts);
      relParts.add('noopener');
      relParts.add('noreferrer');

      return {
        tagName,
        attribs: {
          ...attribs,
          rel: Array.from(relParts).join(' '),
        },
      };
    },
  },
  disallowedTagsMode: 'discard',
};
